import { defineStore } from "pinia";

export const useGuideStore = defineStore("GuideStore", {
  state: () => ({
    faqData: [],
    faqTopic: [],
  }),
  getters: {},
  actions: {
    async getFaqNew2(params) {
      try {
        const res = await $fetch("/api/myspilcom/list-faq-golang", {
          method: "POST",
          body: params,
        });
        if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
          const data = res.data[0];
          this.faqData = data?.faqdata || [];
          this.faqTopic = (data?.faqtopic || []).sort(
            (a, b) => a.indextopic - b.indextopic
          );
        }
        return res;
      } catch (error) {
        console.error("API error:", error);
        return null;
      }
    },
  },
});
